import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authMutationKeys } from '../constants'

export const useLoginVerifyEmailMutation = () => {
  const handleVerifyEmail = async (token) => {
    const config = {
      method: 'post',
      data: {
        token
      }
    }

    const { data } = await api('/api/me/email/verify', config)

    return data
  }

  const handleMutation = async ({ token }) => {
    await handleVerifyEmail(token)
  }

  return useMutation({
    mutationFn: async (credentials) => await handleMutation(credentials),
    mutationKey: authMutationKeys.EMAIL_MUTATION
  })
}
